import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const carAgeOfPrimaryUserSelector = selector<number>({
    key: 'carAgeOfPrimaryUserSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const currentProduct = get(getOnsaCurrentProductSelector);
        const isLoggedOn = get(isLoggedOnSelector);

        return await OnlineSalesUnauthenticated.getPrimaryUserAge(
            jobNumber,
            sessionId,
            currentProduct.fixedId,
            !isLoggedOn
        );
    }
});
